module.exports = "/images/vendor/flag-icon-css/flags/4x3/za.svg?14e7052257d9914b613fc992186d2e90";